<template>
    <div class="container-fluid">
        <nav class="navbar navbar-dark navbar-expand-md navbar-light fixed-top">
            <a class="navbar-brand ms-3  nav-link"
               href="#uvod">
<!--                <img id="brand-img"-->
<!--                     src="/images/logo_w.png"-->
<!--                     class="navbar-bg-resized">-->
                <span class="navbar-bg-resized" id="brand-img">
                    Čerstvě utrženo Haná
                </span>
            </a>
            <!--

            <li class="nav-link d-none d-sm-inline-block">
                <img src="/img/agrohana.png" style="width: 180px;">
            </li>
            -->

            <button class="navbar-toggler"
                    type="button"
                    id="toogler"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarCollapse"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse"
                 id="navbarCollapse" >
                <ul class="navbar-nav ms-auto me-3">
                    <li class="nav-item">
                        <a class="nav-link"
                           href="#uvod">Úvod</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"
                           href="#kontakt">Kontakt</a>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'navbar-top-light',
}

// Navbar scroll bg override
var $win = $(window);
var winH = 50;

$(window).scroll(function () {
    var scroll = $(window).scrollTop();

    //>=, not <=
    if (scroll >= winH) {
        //clearHeader, not clearheader - caps H
        $("#brand-img")
            .addClass("navbar-bg-shrink")
            .removeClass("navbar-bg-resized");
    } else {
        $("#brand-img")
            .removeClass("navbar-bg-shrink")
            .addClass("navbar-bg-resized");
    }
}); //missing );

$(window).scroll(function () {
    var scroll = $(window).scrollTop();

    //>=, not <=
    if (scroll >= winH) {
        //clearHeader, not clearheader - caps H
        $(".navbar").addClass("nav-bg-scrolled");
    } else {
        $(".navbar").removeClass("nav-bg-scrolled");
    }
}); //missing );

// Mobile navbar auto hide on click
$(function () {

        var navMain = $(".navbar-collapse");// avoid dependency on #id
        // "a:not([data-toggle])" - to avoid issues caused
        // when you have dropdown inside navbar
        navMain.blur(()=>{
            navMain.collapse("hide")
        })
});

</script>
<style>
.circle {
    height: 3em;
    width: 1em;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
}
</style>
